import React, { Fragment, useEffect, useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { useBlog, useSettings } from '@atlas/core';
import { BlogElementSkeleton, Icon, Label } from '@atlas/ui';

import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';
import BlogCard from 'components/Blog/BlogCard';
import { defaultRoutes } from 'components/MainRouter/constants';
import SeoPageText from 'components/SeoPage/SeoPageText';

const { menu } = defaultRoutes;

const Skeleton = ({ elementsCount, isLoading }) => {
  if (!isLoading) return null;

  return (
    <Fragment>
      {Array.from({ length: elementsCount || 5 })
        .map((element, index) => index + 1)
        .map(function (_, index) {
          return (
            <div className="blog-skeleton" key={index}>
              <BlogElementSkeleton height={132} />
            </div>
          );
        })}
    </Fragment>
  );
};

const BlogList = () => {
  const { lang } = useSettings();

  const targetRef = useRef(null);
  const { blogs, getBlogList, isLoading, reset } = useBlog();
  const { quickBet: isQuickBet } = useSettings();
  const { betIdToEdit } = useLocalBetslip();

  const sortedBlogs = useMemo(() => {
    return blogs.sort((a, b) => a['order_position'] - b['order_position']);
  }, [blogs]);

  useEffect(() => {
    getBlogList(lang);
  }, [getBlogList, lang]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  const layoutToScrollClass = cx('layout-to-scroll', { quickbet: isQuickBet || betIdToEdit });

  return (
    <div className={layoutToScrollClass} ref={targetRef}>
      <div className="blog_page">
        <Link className="back-to-container" to={menu}>
          <Icon className="icon-back" name="back" />
          <h1>
            <Label className="title-text" message="Blog" />
          </h1>
        </Link>
        <div className="blog">
          <Skeleton isLoading={isLoading} />
          {sortedBlogs.map(
            ({
              action_url: actionUrl,
              id,
              mobile_image_url: imageUrl,
              short_content: shortContent,
              title,
            }) => (
              <BlogCard
                actionUrl={actionUrl}
                id={id}
                imageUrl={imageUrl}
                isLoading={isLoading}
                key={id}
                shortContent={shortContent}
                title={title}
              />
            ),
          )}
        </div>
      </div>
      <SeoPageText />
    </div>
  );
};

export default BlogList;
